/** UNUSED  */
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserInfoStateStructure, setSelectedMarket } from '@ptl/account-management';
import { GlobalShadowStyleDirective, PtlWindowLocationService } from '@ptl/global-components';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';

@Component({
    selector: 'app-producer-landing-page',
    templateUrl: './producer-landing-page.component.html',
    styleUrls: ['./producer-landing-page.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ProducerLandingPageComponent extends GlobalShadowStyleDirective implements OnInit {
  angularHostUrl: string;
  @Input() medicareLandingPageUrl;
  @Input() smallGroupLandingPageUrl;
  @Input() individualLandingPageUrl;

  loginInfo: UserInfoStateStructure;

  linesOfBusiness = {
    senior: LINE_OF_BUSINESS_ENUM.SENIOR,
    individual: LINE_OF_BUSINESS_ENUM.INDIVIDUAL,
    smallGroup: LINE_OF_BUSINESS_ENUM.SMALL_GROUP
  };

  constructor(
    private windowLocationService: PtlWindowLocationService,
    private ngRedux: NgRedux<StateStructure>
  ) {
    super();
   }

  ngOnInit() {
    this.angularHostUrl = environment.infrastructure.googleCloud.angularHostUrl;
  }
  redirectTo(market: LINE_OF_BUSINESS_ENUM) {
    switch (market) {
      case LINE_OF_BUSINESS_ENUM.SENIOR: {
        this.windowLocationService.goToUrl(this.medicareLandingPageUrl);
        break;
      }
      case LINE_OF_BUSINESS_ENUM.SMALL_GROUP: {
        this.windowLocationService.goToUrl(this.smallGroupLandingPageUrl);
        break;
      }
      case LINE_OF_BUSINESS_ENUM.INDIVIDUAL: {
        this.windowLocationService.goToUrl(this.individualLandingPageUrl);
        break;
      }
    }
    this.ngRedux.dispatch(setSelectedMarket(market));
  }
}
